// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".event[data-v-4f0a161e]{display:grid;grid-template-rows:auto -webkit-min-content;grid-template-rows:auto min-content;background-color:#fff;color:#000;padding:4rem 5rem 7rem 5rem;border-top:5px solid #a8ddb8}.event__action[data-v-4f0a161e]{justify-self:center}", ""]);
// Exports
module.exports = exports;
